import SlotSelect from './SlotSelect';

export default SlotSelect;
